const enum Roles {
    UserId = 1,
    AdminId = 2,
    SuperAdminId = 3,
}

export default Roles;
